"use strict";

exports.__esModule = true;
exports.UpdateReportScreen = void 0;
exports.UpdateReportScreenWithParams = UpdateReportScreenWithParams;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ReportDataProvider = require("../ReportDataProvider");
var _Core = require("../../Core");
var _App = require("../../App");
var _ReportEditor = require("../ReportEditor");
var _ReportCollection = require("../ReportCollection");
var _API = require("../../API");
var _System = require("../../../System");
var _ReportTagContext = require("../ReportTagContext");
var _UI = require("../../../Utils/UI");
var _Widgets = require("../../Widgets");
var _utils = require("../utils");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _dec, _class, _UpdateReportScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Screen which allows users to update existing reports.
 */
var UpdateReportScreen = exports.UpdateReportScreen = (_dec = _ReportCollection.ReportCollectionContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (0, _Widgets.withWidgetsContext)(_class = (_UpdateReportScreen = /*#__PURE__*/function (_Component) {
  function UpdateReportScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSubmit = function (report) {
      var _this$props = _this.props,
        reportCollection = _this$props.reportCollection,
        history = _this$props.history;
      var id = report.id,
        name = report.name,
        element = report.element,
        tags = report.tags;
      var translate = _this.props.translator.translate;
      return reportCollection.update({
        id: id,
        name: name,
        element: element,
        tags: tags
      }).then(function (result) {
        (0, _UI.showSuccessToaster)(translate("ReportScreen.save.success", "Successfully updated the report"));
        history.push((0, _System.getScreenURL)("Report", result, (0, _System.getLocationQuery)(history.location)));
      });
    };
    _this.handleDuplicate = function (report) {
      var _this$props2 = _this.props,
        reportCollection = _this$props2.reportCollection,
        history = _this$props2.history;
      var name = report.name,
        element = report.element,
        tags = report.tags;
      var translate = _this.props.translator.translate;
      var id = name.toLowerCase().trim().replace(/\W+/g, "-").replace(/^-+|-+$/, "");
      return reportCollection.create({
        id: id,
        name: name,
        element: element,
        tags: tags
      }).then(function (result) {
        (0, _UI.showSuccessToaster)(translate("ReportScreen.duplicate.success", "Successfully duplicated the report"));
        history.push((0, _System.getScreenURL)("Report", result, (0, _System.getLocationQuery)(history.location)));
      });
    };
    _this.handleDelete = function (report) {
      var _this$props3 = _this.props,
        reportCollection = _this$props3.reportCollection,
        history = _this$props3.history;
      var translate = _this.props.translator.translate;
      return reportCollection["delete"](report.id).then(function () {
        (0, _UI.showSuccessToaster)(translate("ReportScreen.delete.success", "Successfully deleted the report"));
        history.push((0, _System.getScreenURL)("ReportList"));
      });
    };
    _this.checkIfReportWithProvidedNameExist = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(name) {
        var reportCollection;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              reportCollection = _this.props.reportCollection;
              _context.n = 1;
              return (0, _utils.checkIfReportNameExistInCache)({
                name: name,
                cache: reportCollection.cache,
                hasSearched: reportCollection.hasSearched,
                search: reportCollection.search,
                optimisticSearch: reportCollection.optimisticSearch
              });
            case 1:
              return _context.a(2, _context.v);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return _this;
  }
  _inheritsLoose(UpdateReportScreen, _Component);
  var _proto = UpdateReportScreen.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props4 = this.props,
      translator = _this$props4.translator,
      reportCollection = _this$props4.reportCollection,
      match = _this$props4.match,
      widgets = _this$props4.widgets,
      idProp = _this$props4.id;
    var translate = translator.translate;
    var id = idProp || match && match.params && match.params.id;
    return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
      collection: reportCollection,
      id: id
    }, function (_ref2) {
      var _data$element, _data$element2;
      var data = _ref2.data,
        error = _ref2.error;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
          title: translate("ReportScreen.title.error", "Error Loading Report")
        }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: translate("ReportScreen.navbar.title.error", "Error Loading Report")
        }), /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        }));
      }
      if (!data) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
          title: translate("ReportScreen.loadingText", "Loading {id} ...", {
            id: id
          })
        }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: translate("ReportScreen.loadingText", "Loading {id} ...", {
            id: id
          })
        }), /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
      }
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: data.name,
        "data-testid": "UpdateReportScreen"
      }, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutVisibility, {
        layoutRolesVisibilities: data == null || (_data$element = data.element) == null || (_data$element = _data$element.props) == null ? void 0 : _data$element.rolesVisibility,
        layoutUsersVisibilities: data == null || (_data$element2 = data.element) == null || (_data$element2 = _data$element2.props) == null ? void 0 : _data$element2.usersVisibility
      }, /*#__PURE__*/_react["default"].createElement(_ReportDataProvider.ReportDataProvider, {
        report: data
      }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("UpdateReportScreen.navbar.title", "Edit Report: {reportName}", {
          reportName: data.name
        })
      }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_ReportTagContext.ReportTagContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_Core.DragDropContextProvider, null, /*#__PURE__*/_react["default"].createElement(_ReportEditor.ReportEditor, {
        widgets: data.element.type === "DeviceDetails" ? widgets.deviceDetailsWidgets : widgets.reportWidgets,
        onSubmit: _this2.handleSubmit,
        onDuplicate: _this2.handleDuplicate,
        onDelete: _this2.handleDelete,
        value: data,
        checkIfReportWithProvidedNameExist: _this2.checkIfReportWithProvidedNameExist
      })))))));
    });
  };
  return UpdateReportScreen;
}(_react.Component), _UpdateReportScreen.defaultProps = {
  reportCollection: undefined,
  translator: undefined,
  widgets: undefined
}, _UpdateReportScreen)) || _class) || _class) || _class);
function UpdateReportScreenWithParams(props) {
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  return /*#__PURE__*/_react["default"].createElement(UpdateReportScreen, _extends({}, props, {
    id: id
  }));
}
UpdateReportScreenWithParams.displayName = "UpdateReportScreenWithParams";